module.exports = __webpack_public_path__ + "static/img/Five of Pentacles.a6a75b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Five of Pentacles.jpg
// module id = 1266
// module chunks = 0